import { AxiosError } from 'axios';
import { useState } from 'react';
import { jobStatusApi } from '@/api/linkDriveApi';
import {
  JobStatusApiResponse,
  JobStatusParams,
} from '@/types/api/linkDriveApi';

interface Args {
  params: JobStatusParams;
}

export const useGetJobStatus = () => {
  const [data, setData] = useState<JobStatusApiResponse['data']>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<AxiosError>();

  const getJobStatus = async (args: Args) => {
    try {
      setIsLoading(true);
      const { data } = await jobStatusApi(args.params);
      setData(data);
      return data;
    } catch (err) {
      setError(err as AxiosError);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    getJobStatus,
    error,
  };
};
